import { render } from "./UserNotification.vue?vue&type=template&id=501ad897"
import script from "./UserNotification.vue?vue&type=script&lang=js"
export * from "./UserNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__